<div class="sidenav">
	<div class="backdrop-inner" (mouseup)="handleToggle()" [class]="{ active: active }"></div>
	<ng-container [ngSwitch]="position">
		<sidenav-left *ngSwitchCase="'left'" [active]="active" (closeActive)="handleClose()"></sidenav-left>
		<sidenav-right *ngSwitchCase="'right'" [active]="active" (closeActive)="handleClose()"></sidenav-right>
	</ng-container>
</div>
